import { render, staticRenderFns } from "./SocialDataTable.vue?vue&type=template&id=3f52aabb"
import script from "./SocialDataTable.vue?vue&type=script&lang=js"
export * from "./SocialDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports